<!-- <div *ngIf="this.loading.getLoading()" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div> -->
<!-- <div *ngIf="this.loading.getLoading()" class="progress">
    <div class="color"></div>
</div> -->
<div  *ngIf="this.loading.getLoading()"  class="cssload-container">
    <span class="loader"></span>
</div>